/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {LocalNetworkInfo} from '../../../components/session/local-network-info';
import type {CustomEventModel} from './custom-event-api.service';

/** Keeps the session's custom-event lookup in sync after a successful save. */
@Injectable({providedIn: 'root'})
export class CustomEventCacheService {
  constructor(private readonly localNetworkInfo: LocalNetworkInfo = new LocalNetworkInfo()) {
  }

  update(model: CustomEventModel): void {
    this.localNetworkInfo.addCustomEvent({
      id: model.id,
      name: model.name || '',
      type: model.type || 'COUNT',
      priority: model.priority || 0
    });
  }
}
